/**
 * Each value represents the state of the application after
 * the initialization process.
 */
export default {
  FAIL: 0,
  IN_PROCESS: 1,
  SUCCESS: 2,
};
